/**
 * Url Utils
 */

export default {
  /**
   * Get Language Name From Url
   */
  getLangaugeName: function () {
    let match = window.location.href.match(/\/(jp|en|tw|th|ko|cn|id|vn|easy)\b/)
    if(match){
      return match[1]
    }else if(navigator.language){
      switch (navigator.language) {
        case 'en':
          return 'en'
        case 'en-US':
          return 'en'          
        case 'ja':
          return 'jp'
        // case 'zh-TW':
        //   return 'tw'
        // case 'zh-CH':
        //   return 'cn'
        // case 'th':
        //   return 'th'
        // case 'id':
        //   return 'id'
        // case 'ko':
        //   return 'ko'
        // case 'vi':
        //   return 'vi'

        default:
          return 'en'
      }
      // return (navigator.languages[0])?navigator.languages[0]:'jp'
    }
  },


  get_customLink: function(type, lang)
  {
    let sns_link_fb = 'https://www.facebook.com/mcha.jp/'
    let sns_link_twi = 'https://twitter.com/MATCHA_global'
    let sns_link_pin = 'https://jp.pinterest.com/MATCHAglobal/'
    let sns_link_ins = 'https://www.instagram.com/matcha_jp/'
    let sns_link_yt = 'https://www.youtube.com/channel/UCSxODPNwAJXKuSyGlg72kQw'
    let matchaProfile = 'https://company.matcha-jp.com/about'
    let matchaRecruit = 'https://company.matcha-jp.com/career'
    let matchaAbout = 'https://company.matcha-jp.com/'
    let matchaContact = 'https://company.matcha-jp.com/info'
    let fb_app_id = ''
    let fb_lang = '' 
    let fb_page = ''

    switch(lang) {
      case 'jp':
        sns_link_fb = 'https://www.facebook.com/matcha.japanese.jp/?fref=ts';
        sns_link_twi = 'https://twitter.com/MATCHA_PR';
        fb_app_id = '1833805393507221';
        fb_lang = 'ja_JP';
        fb_page = '240454542954202';
        break;

      case 'en':
        matchaProfile = 'https://company.matcha-jp.com/en/about';
        matchaContact = 'https://company.matcha-jp.com/en/info';
        matchaAbout = 'https://company.matcha-jp.com/en/';
        fb_app_id = '1624053081248584';
        fb_lang = 'en_US';
        fb_page = '1462015697360276';
        break;

      case 'tw':
        sns_link_fb = 'https://www.facebook.com/matcha.traditional.chinese/';
        matchaProfile = 'https://company.matcha-jp.com/tw/about';
        matchaContact = 'https://company.matcha-jp.com/tw/info';
        matchaAbout = 'https://company.matcha-jp.com/tw/';
        fb_app_id = '495693607293871';
        fb_lang = 'zh_TW';
        fb_page = '892080184180796';
        break;

      case 'th':
        sns_link_fb = 'https://www.facebook.com/matcha.thai/?fref=ts';
        sns_link_twi = 'https://twitter.com/matcha_thai?lang=th';
        matchaProfile = 'https://company.matcha-jp.com/th/about';
        matchaContact = 'https://company.matcha-jp.com/th/info';
        matchaAbout = 'https://company.matcha-jp.com/th/';
        fb_app_id = '1161004997280990';
        fb_lang = 'th_TH';
        fb_page = '330507393788421';
        break;

      case 'ko':
        sns_link_fb = 'https://www.facebook.com/matcha.kr/';
        matchaProfile = 'https://company.matcha-jp.com/ko/about';
        matchaContact = 'https://company.matcha-jp.com/ko/info';
        matchaAbout = 'https://company.matcha-jp.com/ko/';
        fb_app_id = '1710721759178103';
        fb_lang = 'ko_KR';
        fb_page = '712607058821518';
        break;

      case 'cn':
        matchaProfile = 'https://company.matcha-jp.com/cn/about';
        matchaContact = 'https://company.matcha-jp.com/cn/info';
        matchaAbout = 'https://company.matcha-jp.com/cn/';
        fb_app_id = '1037160099705428';
        fb_lang = 'zh_CN';
        break;

      case 'id':
        sns_link_fb = 'https://www.facebook.com/matcha.indonesian/?fref=ts';
        sns_link_twi = 'https://twitter.com/matcha_ina?lang=id';
        matchaProfile = 'https://company.matcha-jp.com/id/about';
        matchaContact = 'https://company.matcha-jp.com/id/info';
        matchaAbout = 'https://company.matcha-jp.com/id/';
        fb_app_id = '564340460442983';
        fb_lang = 'id_ID';
        fb_page = '663938143748913';
        break;

      case 'vn':
        sns_link_fb = 'https://www.facebook.com/matcha.vn/';
        matchaProfile = 'https://company.matcha-jp.com/vn/about';
        matchaContact = 'https://company.matcha-jp.com/vn/info';
        matchaAbout = 'https://company.matcha-jp.com/vn/';
        fb_app_id = '722848357858128';
        fb_lang = 'vi_VN';
        break;

      case 'es':
        sns_link_fb = 'https://www.facebook.com/matcha.es/fa';
        matchaProfile = 'https://company.matcha-jp.com/en/about';
        matchaContact = 'https://company.matcha-jp.com/en/info';
        matchaAbout = 'https://company.matcha-jp.com/en/';
        fb_lang = 'es_MX';
        break;

      case 'easy':
        sns_link_fb = 'https://www.facebook.com/matcha.japanese.jp/?fref=ts';
        sns_link_twi = 'https://twitter.com/MATCHA_PR';
        fb_app_id = '1759855830923639';
        fb_lang = 'ja_JP';
        fb_page = '360231064184314';
        break;
    }

    switch (type) {
      case 'sns_link_fb':
        return sns_link_fb;

      case 'sns_link_twi':
        return sns_link_twi;

      case 'sns_link_pin':
        return sns_link_pin;

      case 'sns_link_ins':
        return sns_link_ins;

      case 'sns_link_yt':
        return sns_link_yt;

      case 'matchaProfile':
        return matchaProfile;

      case 'matchaRecruit':
        return matchaRecruit;

      case 'matchaAbout':
        return matchaAbout;

      case 'matchaContact':
        return matchaContact;

      case 'fb_app_id':
        return fb_app_id;

      case 'fb_lang':
        return fb_lang;

      case 'fb_page':
        return fb_page;
    }    

  }

}



// WEBPACK FOOTER //
// ./src/utils/UrlUtils.js